import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import useWorkspaceSystem from '../systems/useWorkspaceSystem';
import { NonMemberJSON } from '../types';
import { WorkspaceQueryInvalidator } from './queryInvalidator';

type Params = {
	workspaceID: number;
	onSuccess: () => void;
};

const useAssignSeatToNonMemberMutation = ( { workspaceID, onSuccess }: Params ) => {
	const system = useWorkspaceSystem();
	const queryClient = useQueryClient();
	const [ error, setError ] = useState<string | null>( null );

	const mutation = useMutation(
		( nonMember: NonMemberJSON ) => system.assignSeatToNonMember( {
			workspaceID, nonMember
		} ),
		{
			onSuccess: () => {
				WorkspaceQueryInvalidator.invalidateNonMembers(
					workspaceID, { queryClient, refetchActiveQueries: true }
				);
				WorkspaceQueryInvalidator.invalidateWorkspaceMembers(
					workspaceID, { queryClient, refetchActiveQueries: true }
				);
				onSuccess();
			},
			onError: () => {
				setError( 'Something went wrong. Please try again.' );
			}
		}
	);

	return { ...mutation, error };
};

export default useAssignSeatToNonMemberMutation;
